'use client';

import s from './styles.module.scss';
import Image from 'next/image';
import useEmblaCarousel from 'embla-carousel-react';
import { ReviewsProps } from '@/src/components/sections/Reviews';
import { useCallback } from 'react';
import { whatAwaits } from '@/src/mocks/what-awaits';

export const WhatAwaits = ({ controls, options }: ReviewsProps) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        align: 'start',
        dragFree: false,
        containScroll: 'trimSnaps',
        skipSnaps: false,
        slidesToScroll: 1,
        ...options,
    });

    const onPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
    const onNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);

    return (
        <div className={s.root}>
            <h2 className={s.title}>
                Що на тебе
                <br />
                чекає в кемпі?
            </h2>

            <div className={s.viewport} ref={emblaRef}>
                <div className={s.container}>
                    {whatAwaits.map((r) => (
                        <article key={r.id} className={s.slide}>
                            <div className={s.card}>
                                <Image src={r.card} alt="" width={370} height={370} />
                            </div>
                        </article>
                    ))}
                </div>

                <div className={`${s.controls} ${controls?.className ?? ''}`.trim()}>
                    <button
                        type="button"
                        className={`${s.navBtn} ${s.prev}`}
                        onClick={onPrev}
                        aria-label="Попередній відгук"
                    >
                        {controls?.prevContent ?? (
                            <Image
                                className={s.icon}
                                src="/icons/arrow_slider.svg"
                                alt=""
                                aria-hidden
                                width={20}
                                height={20}
                            />
                        )}
                    </button>
                    <button
                        type="button"
                        className={`${s.navBtn} ${s.next}`}
                        onClick={onNext}
                        aria-label="Наступний відгук"
                    >
                        {controls?.nextContent ?? (
                            <Image
                                className={s.icon}
                                src="/icons/arrow_slider.svg"
                                alt=""
                                aria-hidden
                                width={20}
                                height={20}
                            />
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};
